import { type Noticeboard } from "shared/lib";

import { ProgressIndicatorListStatus } from "shared/components";
import { getText } from "shared/lib";

export type ProgressIndicatorItem = {
  status: ProgressIndicatorListStatus;
  text: string;
  icon: string;
};

export type ProgressIndicatorItemMap = {
  [expertName: string]: ProgressIndicatorItem;
};

export function getReportLoadingProgressIndicatorItemsMap(): ProgressIndicatorItemMap {
  return {
    proposed_land_use_assessor: {
      status: ProgressIndicatorListStatus.none,
      text: getText("Assessing the land use against your zone requirements"),
      icon: "🔍",
    },
    landuse_section: {
      status: ProgressIndicatorListStatus.none,
      text: getText(
        "Reviewing buildings and works conditions against overlay legislation",
      ),
      icon: "🚧",
    },
    zone_works_report: {
      status: ProgressIndicatorListStatus.none,
      text: getText("Evaluating potential impacts to vegetation"),
      icon: "🌳",
    },
    // sign_assessor: {
    //   status: ProgressIndicatorListStatus.none,
    //   text: "Checking for signage requirements",
    //   icon: "🪧",
    // },
    customer_report: {
      status: ProgressIndicatorListStatus.none,
      text: getText("Summarising findings"),
      icon: "📝",
    },
  };
}

export function getReportLoadingProgressIndicatorItems(
  noticeboardData: Noticeboard,
  latestUserMessageNumber: number,
  expertNamesMap: ProgressIndicatorItemMap,
) {
  const expertNames = Object.keys(expertNamesMap);

  const expertsStatuses = expertNames.reduce(
    (statuses, expertName) => {
      if (
        noticeboardData[expertName]?.message_number === latestUserMessageNumber
      ) {
        statuses[expertName] = ProgressIndicatorListStatus.done;
      } else {
        statuses[expertName] = ProgressIndicatorListStatus.none;
      }
      return statuses;
    },
    {} as { [expertName: string]: ProgressIndicatorListStatus },
  );

  return expertNames.map((expertName, index) => {
    const item = { ...expertNamesMap[expertName] };

    if (index === 0) {
      item.status =
        expertsStatuses[expertName] === ProgressIndicatorListStatus.done
          ? ProgressIndicatorListStatus.done
          : ProgressIndicatorListStatus.loading;
    } else if (
      expertsStatuses[expertName] === ProgressIndicatorListStatus.done
    ) {
      item.status = ProgressIndicatorListStatus.done;
    } else if (
      expertsStatuses[expertNames[index - 1]] ===
      ProgressIndicatorListStatus.done
    ) {
      item.status = ProgressIndicatorListStatus.loading;
    } else {
      item.status = ProgressIndicatorListStatus.none;
    }

    return item;
  });
}
